import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State { error: Error | null }

/** Catches rendering errors so one broken view never blanks the whole app. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ChemAI view error', error, info.componentStack);
    // automatic error report (static/feedback.js); no personal data
    try { (window as unknown as { __chemaiReport?: (e: unknown, k: string) => void }).__chemaiReport?.(Object.assign(new Error(error.message), { stack: `${error.stack ?? ''}\n${info.componentStack ?? ''}`.slice(0, 1500) }), 'react'); } catch { /* ignore */ }
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="page" role="alert">
          <h1>Something went wrong · Ceva nu a funcționat · Bir şeyler ters gitti</h1>
          <p className="mono small">{this.state.error.message}</p>
          <button type="button" className="btn btn-primary" onClick={() => { this.setState({ error: null }); window.location.assign('/'); }}>
            ⌂ Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
